import { render, staticRenderFns } from "./nodeWrap.vue?vue&type=template&id=12c00388&scoped=true&"
import script from "./nodeWrap.vue?vue&type=script&lang=ts&"
export * from "./nodeWrap.vue?vue&type=script&lang=ts&"
import style0 from "./nodeWrap.vue?vue&type=style&index=0&id=12c00388&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c00388",
  null
  
)

export default component.exports